import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { CSSTransitionWithRef } from 'site-modules/shared/components/css-transition-with-ref/css-transition-with-ref';
import { ANIMATION_TIMEOUT } from 'site-modules/shared/components/incentives/incentives-wizard/constants/animations';

export function IncentivesWizardTransition({ currentStepIndex = 0, wizardRef = null, onSetStyle, children }) {
  const containerHeight = useRef(0);

  useEffect(() => {
    const wizardNode = wizardRef?.current;
    if (!wizardNode) return;

    const height = wizardNode.clientHeight;
    onSetStyle('height', `${height}px`);
    containerHeight.current = height;
  }, [onSetStyle, wizardRef]);

  const handleOnEnter = useCallback(() => {
    onSetStyle('height', `${containerHeight.current}px`);
  }, [onSetStyle]);

  const handleOnEntered = useCallback(() => {
    onSetStyle('height', null);
    onSetStyle('minHeight', `${containerHeight.current}px`);
  }, [onSetStyle]);

  const handleOnExiting = () => {
    const wizardNode = wizardRef?.current;
    if (!wizardNode) return;

    const height = wizardNode.clientHeight;
    containerHeight.current = height;
    onSetStyle('height', `${height}px`);
    onSetStyle('minHeight', null);
  };

  return (
    <TransitionGroup component={null}>
      <CSSTransitionWithRef
        key={currentStepIndex}
        timeout={ANIMATION_TIMEOUT}
        classNames="fade"
        onEnter={handleOnEnter}
        onEntered={handleOnEntered}
        onExiting={handleOnExiting}
        mountOnEnter
        unmountOnExit
      >
        {children}
      </CSSTransitionWithRef>
    </TransitionGroup>
  );
}

IncentivesWizardTransition.propTypes = {
  currentStepIndex: PropTypes.number,
  wizardRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  children: PropTypes.node.isRequired,
  onSetStyle: PropTypes.func.isRequired,
};
